<app-expandable-section-box
  [title]="'Repurposed Articles'"
  [iconClass]="'icon-list-alt'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div class="space-y-2 divide-y-2" *ngIf="repurposedTo.length > 0">
      <p class="text-xs">Repurposed to:</p>
      <div *ngFor="let content of repurposedTo">
        <p class="text-xs">
          Created By: {{ content.user }},
          <a (click)="redirect(content)">
            {{ content.createdDate | date: "dd/MM/yyyy - HH:mm" }}</a
          >
        </p>
      </div>
    </div>
    <div class="space-y-2 divide-y-2" *ngIf="repurposedFrom.length > 0">
      <p class="text-xs">Repurposed from:</p>
      <div *ngFor="let content of repurposedFrom">
        <p class="text-xs">
          Created By: {{ content.user }},
          <a (click)="redirect(content)">
            {{ content.createdDate | date: "dd/MM/yyyy - HH:mm" }}</a
          >
        </p>
      </div>
    </div>
  </div>
</app-expandable-section-box>
